import { WifiOff } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNetworkStatusContext } from "@/contexts/NetworkStatusContext";

export const OfflineBanner: React.FC = () => {
  const { isOnline } = useNetworkStatusContext();
  const { isOfflineWithExpiredToken } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  // Auto-collapse to thin bar after 10s offline
  useEffect(() => {
    if (isOnline) {
      setCollapsed(false);
      return;
    }
    const timer = setTimeout(() => setCollapsed(true), 10_000);
    return () => clearTimeout(timer);
  }, [isOnline]);

  if (isOnline) return null;

  if (collapsed) {
    return (
      <button
        type="button"
        onClick={() => setCollapsed(false)}
        className="h-1 w-full bg-amber-400 transition-all duration-300 dark:bg-amber-600"
        aria-label="Expand offline notification"
      />
    );
  }

  const message = isOfflineWithExpiredToken
    ? "You're offline — session expired, changes won't sync until you reconnect"
    : "You're offline — showing data from your last visit";

  return (
    <div className="flex items-center justify-center gap-2 bg-amber-50/90 px-4 py-2 text-sm text-amber-800 backdrop-blur-sm transition-all duration-300 dark:bg-amber-950/90 dark:text-amber-200">
      <WifiOff className="h-4 w-4 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
};
